import PokeStyle from "Examples/PokeDex/style.module.scss";
import usePokeInfoModal from "Examples/PokeDex/usePokeInfoModal";
import { Spinner } from "react-bootstrap";

export type PokeModal = {
  id: number;
  visible?: boolean;
  onClickBack?: () => void;
};

const PokemonModal: React.FC<PokeModal> = ({ id, visible, onClickBack }) => {
  const [
    pokeDetalles,
    pokeColor,
    pokeCategory,
    pokeLocation,
    pokeImg,
    loading
  ] = usePokeInfoModal(id);
  if (!visible) return <></>;
  return (
    <div className={PokeStyle.PokemonModalBack} onClick={onClickBack}>
      <div className={PokeStyle.gif}>
        {loading ? (
          <Spinner animation='border' />
        ) : (
          <div
            className={PokeStyle.PokemonModal}
            style={{ borderColor: pokeColor }}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}>
            <div className={PokeStyle.modalImg}>
              {pokeImg?.img && <img src={pokeImg?.img} alt='modalImgFront' />}
              {pokeImg?.imgBack && (
                <img src={pokeImg?.imgBack} alt='modalImgBack' />
              )}
            </div>
            <div
              className={PokeStyle.modalDetalles}
              data-testid='modal-detalles'>
              <h4>Name: {pokeDetalles?.pokeName}</h4>
              {pokeDetalles?.pokeAbility && (
                <h4>Ability: {pokeDetalles?.pokeAbility}</h4>
              )}
              {pokeDetalles?.pokeForm && (
                <h4>Form: {pokeDetalles?.pokeForm}</h4>
              )}
              {pokeDetalles?.pokeMove && (
                <h4>Move: {pokeDetalles?.pokeMove}</h4>
              )}

              {pokeDetalles?.pokeSpecies && (
                <h4>Species: {pokeDetalles?.pokeSpecies}</h4>
              )}
              {pokeDetalles?.pokeStatNumber && (
                <h4>
                  Stat: {pokeDetalles?.pokeStatNumber}
                  {pokeDetalles?.pokeStatName}
                </h4>
              )}
              {pokeDetalles?.pokeType && (
                <h4>Type: {pokeDetalles?.pokeType}</h4>
              )}
              {pokeCategory && <h4>Category: {pokeCategory}</h4>}
              {pokeLocation && <h4>Location: {pokeLocation}</h4>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PokemonModal;
